import { get } from 'lodash';

import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';

export default [
  {
    label: 'Název',
    field: 'name',
    type: ColumnType.TEXT,
    width: 150
  },
  {
    label: 'Kategorie',
    field: 'category.name',
    displayField: 'category',
    mapper: parent => get(parent, 'name'),
    type: ColumnType.TEXT,
    width: 150
  },
  {
    label: 'Strážník',
    field: 'employee.name',
    displayField: 'employee',
    mapper: o => get(o, 'fullName'),
    type: ColumnType.TEXT,
    width: 150
  }
];



// WEBPACK FOOTER //
// ./src/modules/myItems/_myItemsColumns.ts